module.exports = __webpack_public_path__ + "static/media/CardInitial.0aae944d.svg";